import React from 'react';
import AnalysisPage from './AnalysisPage'

const AlertContractor = () => {
    const filters = [
        {
            name: "Company",
            type: "dropdown",
            options: ["CoolGreen"],
        },
        {
            name: "Spend",
            type: "button",
        },
        {
            name: "Quality",
            type: "button",
        },
        {
            name: "Hourly",
            type: "date",
        },
        {
            name: "Start Date",
            type: "date",
        },
        {
            name: "End Date",
            type: "date",
        },
    ];

    return (
        <AnalysisPage title="Contractor" filters={filters}></AnalysisPage>
    )
};

export default AlertContractor;
